<template>

    <loader v-if="loading"></loader>
    <div v-else style="padding: 20px" class="full-screen-scroll-content">
        <add-taxi-company v-if="show_add_taxi" @close="onCloseModal"></add-taxi-company>
        <edit-taxi-company v-if="edit_taxi" :taxi_company="edit_taxi" @close="onEditClose"></edit-taxi-company>
        <div class="header">
            <h2>Taxi</h2>
            <el-button type="primary" @click="show_add_taxi = true">Add new</el-button>
        </div>
        <el-table
                :data="all_taxi_types.filter(el => el.name.toLowerCase().includes(search.toLowerCase()) ||  el.cityName.toLowerCase().includes(search.toLowerCase()))"
                height="80vh"
        >
            <el-table-column
                    @click="edit_taxi = true"
                    prop="name"
                    label="Name"
            >
            </el-table-column>
            <el-table-column
                    prop="phoneNumber"
                    label="Phone number">
            </el-table-column>
            <el-table-column
                    prop="email"
                    label="Email">
            </el-table-column>
            <el-table-column
                    prop="cityName"
                    label="City">
            </el-table-column>
            <el-table-column
                    align="right">
                <template slot="header">
                    <label>
                        <input
                                class="no-border-input"
                                style="padding: 5px; border-radius: 4px"
                                v-model="search"
                                size="mini"
                                placeholder="Type to search"/>
                    </label>
                </template>
            </el-table-column>
            <el-table-column
                    fixed="right"
                    label="Operations"
                    width="120">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="onEditClick(scope)">Edit</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import {mapMutations, mapState} from "vuex";
    import TaxiService from '@/common/services/taxi.service'
    import mutations from "@/store/mutation_types";
    import Loader from "../common/components/loader";
    import AddTaxiCompany from "../components/taxi/AddTaxiCompany";
    import EditTaxiCompany from "../components/taxi/EditTaxiCompany";

    export default {
        name: 'Taxi',
        components: {EditTaxiCompany, AddTaxiCompany, Loader},
        data() {
            return {
                taxi: [],
                search: '',
                loading: false,
                show_add_taxi: false,
                edit_taxi: false
            }
        },
        computed: {
            ...mapState({
                user: state => state.user,
                all_taxi_types: state => state.taxi_types
            }),

            filterTaxi() {
                let search = this.search.toLowerCase();
                return this.all_taxi_types.filter(el => el.name.includes(search) || el.cityName.includes(search))
            }

        },
        methods: {
            ...mapMutations(['SET_TAXI_TYPES']),
            onCloseModal(success) {
                this.show_add_taxi = false;
                if (success) {
                    this.getTaxiTypes();
                }
            }
            ,
            onEditClose(success) {
                this.edit_taxi = null;
                if (success) {
                    this.getTaxiTypes();
                }
            }
            ,

            onEditClick(row) {
                this.edit_taxi = JSON.parse(JSON.stringify(row.row))
            },
            getTaxiTypes() {
                this.loading = true;
                let payload = {
                    "email": this.user.user_email,
                    "cityName": "TETOVO"
                };
                TaxiService.getTaxiTypes(payload).then(response => {
                    this[mutations.SET_TAXI_TYPES](response.data)
                }).catch(error => {
                    this.$notify.error({
                        title: `Failed to taxi types`,
                        message: error.response.data.message
                    });
                }).finally(() => this.loading = false)
            }
        },
        beforeMount() {
            this.getTaxiTypes()
        }
    }
</script>

<style scoped lang="scss">

    textarea:focus, input:focus {
        outline: none;
    }


    .header {
        display: flex;
        justify-content: space-between;
        padding: 10px 10px;
        align-items: center;
    }
</style>
